define(function () {
  var headerCtrl = function (header_class_name) {
    "use strict";
    var sectionHeaders = document.getElementsByClassName(header_class_name);
    var mainContainer = document.getElementsByClassName('main-container-wrapper');
    var headerContainer = document.getElementsByClassName('header');
    var headerH = 0;

    if(sectionHeaders.length > 0) {
      sectionHeaders = sectionHeaders[0];
    }

    if(mainContainer.length > 0) {
      mainContainer = mainContainer[0];
    }

    if(headerContainer.length > 0) {
      headerContainer = headerContainer[0];
    }

    var last_known_scroll_position = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);
    var ticking = false;
    headerH = sectionHeaders.offsetHeight - headerContainer.offsetHeight;
    updateHeader(last_known_scroll_position);

    var onScrolling = function (ev) {
      last_known_scroll_position = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

      if (!ticking) {
        window.requestAnimationFrame(function() {
          updateHeader(last_known_scroll_position);
          ticking = false;
        });
      }
      ticking = true;
    };
    document.onscroll = onScrolling;

    function updateHeader(scroll_pos) {
      if(scroll_pos >= headerH ) {
        headerContainer.style.backgroundColor = 'rgba(42, 55, 68, 1)';
      }
      else if(scroll_pos > 0 && scroll_pos < headerH) {
        headerContainer.style.backgroundColor = 'rgba(42, 55, 68, '+ 1*scroll_pos/headerH +')';
      }
      else {
        headerContainer.style.backgroundColor = 'rgba(42, 55, 68, 0)';
      }
    }
  };

  var Home = function () {

  };

  Home.prototype.actionIndex = function () {
    headerCtrl('ca-section-header');
  };

  Home.prototype.actionCandidates = function () {
    headerCtrl('ca-section-cand-header');
  };

  Home.prototype.actionFeatures = function () {
    headerCtrl('ca-section-features-header');
    // media query event handler
    var mq = window.matchMedia("screen and (max-width: 767px)");
    mq.addListener(WidthChange);
    WidthChange(mq);
  };

  return Home;
});


// media query change
function WidthChange(mq) {
  if (mq.matches) {
    $('.tab-pane').each(function(i,t){
      $(this).addClass('active in');
    });
  } else {
    $('.tab-pane').each(function(i,t){
      $(this).attr('class', 'tab-pane');
      if (i == 0)
        $(this).addClass('active in');
    });
  }
}